import React from "react";
import { FiCopy, FiCheck } from "react-icons/fi";
import OnboardingCard from "../../components/OnboardingComponents/OnboardingCard";
import OnboardingButton from "../../components/OnboardingComponents/OnboardingButton";
import { getAvatarColor } from "./utils";

interface CustomerListViewProps {
  customers: MasterCustomer[];
  copiedEmailId: string | null;
  setCopiedEmailId: (id: string | null) => void;
  impersonatingId: string | null;
  handleImpersonate: (customer: MasterCustomer) => void;
}

export const CustomerListView = ({
  customers,
  copiedEmailId,
  setCopiedEmailId,
  impersonatingId,
  handleImpersonate,
}: CustomerListViewProps) => (
  <div className="flex flex-col">
    <div className="hidden md:grid grid-cols-[1fr_2fr_1.5fr_12rem] items-center gap-4 rounded-xl border border-[#A2B2C833] bg-white px-8 py-4 mb-3 shadow-sm">
      <span className="text-sm uppercase tracking-wider text-black font-bold font-['Proxima_Nova']">
        User
      </span>
      <span className="text-sm uppercase tracking-wider text-black font-bold font-['Proxima_Nova'] text-center">
        Email
      </span>
      <span className="text-sm uppercase tracking-wider text-black font-bold font-['Proxima_Nova'] text-center">
        Customer ID
      </span>
      <span className="text-sm uppercase tracking-wider text-black font-bold font-['Proxima_Nova'] text-center">
        Action
      </span>
    </div>

    <div className="flex flex-col gap-4">
      {customers.map((c: MasterCustomer) => {
        const fullName =
          [c.firstName, c.lastName].filter(Boolean).join(" ") || "Unknown User";

        const initials = (
          `${c.firstName?.[0] || ""}${c.lastName?.[0] || ""}` || "U"
        ).toUpperCase();

        return (
          <OnboardingCard
            key={c._id}
            className="px-8 py-5 flex flex-col gap-4 md:grid md:grid-cols-[1fr_2fr_1.5fr_12rem] md:items-center"
          >
            <div className="flex items-center gap-4 min-w-0">
              <div
                className={`flex h-[50px] w-[50px] shrink-0 items-center justify-center rounded-full ${getAvatarColor(
                  c._id
                )} text-lg font-bold text-white shadow-sm`}
              >
                {initials}
              </div>
              <div className="min-w-0">
                <p className="font-['Canela_Text'] font-bold text-[18px] text-[#1A1F3C] truncate">
                  {fullName}
                </p>
              </div>
            </div>

            <div className="group/email flex items-center gap-1.5 min-w-0 md:justify-center">
              <p
                className="font-['Proxima_Nova'] text-[16px] text-[#46464D] truncate"
                title={c.email || "No Email"}
              >
                {c.email || "No Email"}
              </p>
              {c.email && (
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(c.email);
                    setCopiedEmailId(c._id);
                    setTimeout(() => setCopiedEmailId(null), 2000);
                  }}
                  className="shrink-0 p-1 rounded-md text-[#A2B2C899] hover:text-[#1A1F3C] hover:bg-[#EAEBF0] opacity-0 group-hover/email:opacity-100 focus:opacity-100 transition-all"
                  title="Copy email"
                >
                  {copiedEmailId === c._id ? (
                    <FiCheck size={15} className="text-green-600" />
                  ) : (
                    <FiCopy size={15} />
                  )}
                </button>
              )}
            </div>

            <p className="font-['Proxima_Nova'] text-[16px] font-semibold text-[#030724] truncate md:text-center">
              {c.zohoCustomerId || "Not Available"}
            </p>

            <div className="md:justify-self-end w-full md:w-auto">
              <OnboardingButton
                title="IMPERSONATE"
                variant="filled"
                className="!py-3 !px-6"
                onClick={() => handleImpersonate(c)}
                loading={impersonatingId === c._id}
                disabled={impersonatingId === c._id}
              />
            </div>
          </OnboardingCard>
        );
      })}
    </div>
  </div>
);
